var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8258 37.6979C29.2229 37.6979 37.6515 29.259 37.6515 18.849C37.6515 8.43897 29.2229 0 18.8258 0C8.42858 0 0 8.43897 0 18.849C0 29.259 8.42858 37.6979 18.8258 37.6979ZM18.8258 36.6824C28.6628 36.6824 36.6372 28.6981 36.6372 18.849C36.6372 8.99985 28.6628 1.01557 18.8258 1.01557C8.98878 1.01557 1.01432 8.99985 1.01432 18.849C1.01432 28.6981 8.98878 36.6824 18.8258 36.6824Z",
    fill: "#BA0315",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1566 19.6551L44.4697 9.138H45.4762L46.7893 19.6551C48.3222 31.9327 57.7408 41.7369 69.9343 43.7478L72.9493 44.245L72.9493 45.2471L69.9343 45.7443C57.7408 47.7553 48.3222 57.5595 46.7893 69.837L45.4762 80.3542H44.4697L43.1566 69.837C41.6237 57.5595 32.2052 47.7553 20.0116 45.7443L16.9966 45.2471V44.245L20.0116 43.7478C32.2052 41.7369 41.6237 31.9327 43.1566 19.6551ZM44.973 13.2947L44.1631 19.7811C42.5754 32.4974 32.8253 42.6535 20.1995 44.7461C32.8253 46.8387 42.5754 56.9948 44.1631 69.7111L44.973 76.1975L45.7828 69.7111C47.3705 56.9948 57.1207 46.8387 69.7465 44.7461C57.1207 42.6535 47.3705 32.4974 45.7828 19.7811L44.973 13.2947Z",
    fill: "#BA0315",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8258 90C29.2229 90 37.6515 81.561 37.6515 71.151C37.6515 60.741 29.2229 52.3021 18.8258 52.3021C8.42858 52.3021 0 60.741 0 71.151C0 81.561 8.42858 90 18.8258 90ZM18.8258 88.9844C28.6628 88.9844 36.6372 81.0001 36.6372 71.151C36.6372 61.3019 28.6628 53.3176 18.8258 53.3176C8.98878 53.3176 1.01432 61.3019 1.01432 71.151C1.01432 81.0001 8.98878 88.9844 18.8258 88.9844Z",
    fill: "#BA0315",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 71.151C90 81.561 81.5714 90 71.1742 90C60.7771 90 52.3485 81.561 52.3485 71.151C52.3485 60.741 60.7771 52.3021 71.1742 52.3021C81.5714 52.3021 90 60.741 90 71.151ZM88.9857 71.151C88.9857 81.0001 81.0112 88.9844 71.1742 88.9844C61.3372 88.9844 53.3628 81.0001 53.3628 71.151C53.3628 61.3019 61.3372 53.3176 71.1742 53.3176C81.0112 53.3176 88.9857 61.3019 88.9857 71.151Z",
    fill: "#BA0315",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 18.849C90 29.259 81.5714 37.6979 71.1742 37.6979C60.7771 37.6979 52.3485 29.259 52.3485 18.849C52.3485 8.43897 60.7771 0 71.1742 0C81.5714 0 90 8.43897 90 18.849ZM88.9857 18.849C88.9857 28.6981 81.0112 36.6824 71.1742 36.6824C61.3372 36.6824 53.3628 28.6981 53.3628 18.849C53.3628 8.99985 61.3372 1.01557 71.1742 1.01557C81.0112 1.01557 88.9857 8.99985 88.9857 18.849Z",
    fill: "#BA0315",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6fb38f8b83832d2764da8153eecc39cc.svg";
export { ForwardRef as ReactComponent };